import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import DialogBox from "../../util/DialogBox";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { authApi } from "../../../api/auth";
import { getNewPasswordError } from "../../../api/passwordPolicy";

function ResetPage() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [newMdp, setNewMdp] = useState("");
  const [confirmMdp, setConfirmMdp] = useState("");

  const navigate = useNavigate();
  const { t } = useTranslation();

  /**
   * Réinitialisation via POST /auth/reset-password avec le jeton reçu par
   * e-mail. Aucune lecture d'utilisateur, aucun hash comparé côté client.
   */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newMdp !== confirmMdp) {
      DialogBox({
        text: t("samePwdTwice"),
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    const passwordError = getNewPasswordError(newMdp);
    if (passwordError) {
      DialogBox({ text: t(passwordError), icon: "warning", confirmButtonText: "OK" });
      return;
    }

    const { status } = await authApi.resetPassword({
      token,
      password: newMdp,
    });

    if (status === 200) {
      DialogBox({
        text: t("successResetMdp"),
        icon: "success",
        confirmButtonText: "OK",
      });
      navigate("/Connexion");
    } else {
      DialogBox({
        text: t(status === 429 ? "authTooManyAttempts" : "resetPasswordError"),
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <div className="App d-flex align-items-center justify-content-center vh-100">
      <div className="accessPage h-50 w-25">
        <form onSubmit={handleSubmit}>
          <h6 className="text-center mt-2">{t("writeNewPwd")}</h6>
          <div className="input-group mt-3">
            <input
              type={showPassword ? "text" : "password"}
              className="form-control"
              placeholder={t("saisirMdpPlaceholder")}
              value={newMdp}
              aria-describedby="reset-password-requirements"
              required
              onChange={(e) => {
                setNewMdp(e.target.value);
              }}
            />
            <button
              className="btn btn-outline-secondary"
              type="button"
              onClick={() => setShowPassword(!showPassword)}
            >
              <i className="bi bi-eye-slash"></i>
            </button>
          </div>
          <small id="reset-password-requirements" className="d-block mt-2">
            {t("registrationPasswordRequirements")}
          </small>
          <div className="input-group">
            <input
              type={showConfirmPassword ? "text" : "password"}
              className="form-control"
              placeholder={t("confirmPwdPlaceholder")}
              value={confirmMdp}
              required
              onChange={(e) => {
                setConfirmMdp(e.target.value);
              }}
            />
            <button
              className="btn btn-outline-secondary"
              type="button"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            >
              <i className="bi bi-eye-slash"></i>
            </button>
          </div>
          <br />
          <div className="d-flex flex-column align-items-center justify-content-center">
            <input type="submit" value={t("send")} className="btnMenu mt-4" />
            <br />
            <button className="btnBack" onClick={() => navigate("/Connexion")}>
              {t("backConnexionPage")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ResetPage;
